import {
	createContext,
	useContext,
	useEffect,
	useReducer,
} from "react";
import CryptoJS from "crypto-js";
import PPMVReducer from "./PpmvReducer";

export const SURVEY_FORM_INITIAL_DATA = {
	phone_number: "",
	email: "",
	lat: "",
	lng: "",
	state: "",
	lga: "",
	town: "",
	what_type_of_outlet_do_you_operate: "",
	reg_no: "",
	outlet_img_url: "",
	inlet_img_url: "",
	cert_img_url: "",
	whatsapp_number: "",
	contact_name: "",
	shop_name: "",
	shop_address: "",
};

export const STORAGE_KEY = "persist::PPMV::Survey";
const SECRET_KEY = "4HE::e9b2A::c8f7RT::a6BE498||AT";

const encryptData = (data) => {
	const stringData = JSON.stringify(data);
	return CryptoJS.AES.encrypt(stringData, SECRET_KEY).toString();
};

const decryptData = (encryptedData) => {
	const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
	const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
	return JSON.parse(decryptedString);
};

const loadInitialState = () => {
	const savedData = localStorage.getItem(STORAGE_KEY);
	if (savedData) {
		try {
			return { ppmvFormData: decryptData(savedData) };
		} catch (error) {
			console.error("Failed to decrypt survey data:", error);
		}
	}
	return { ppmvFormData: SURVEY_FORM_INITIAL_DATA };
};

const PPMVFormDataContext = createContext({
	ppmvFormData: SURVEY_FORM_INITIAL_DATA,
	dispatch: () => null,
});

const PPMVFormProvider = ({ children }) => {
	const [state, dispatch] = useReducer(PPMVReducer, loadInitialState());

	useEffect(() => {
		if (state.ppmvFormData) {
			try {
				const encryptedData = encryptData(state.ppmvFormData);
				localStorage.setItem(STORAGE_KEY, encryptedData);
			} catch (error) {
				console.error("Failed to encrypt survey data:", error);
			}
		}
	}, [state.ppmvFormData]);

	return (
		<PPMVFormDataContext.Provider
			value={{ ppmvFormData: state.ppmvFormData, dispatch }}
		>
			{children}
		</PPMVFormDataContext.Provider>
	);
};

const usePPMVFormContext = () => {
	const context = useContext(PPMVFormDataContext);
	if (!context) {
		throw new Error(
			"usePPMVFormContext must be used within a PPMVFormProvider"
		);
	}
	return context;
};

export { PPMVFormProvider, usePPMVFormContext };
